import type { TFunction } from 'i18next';

import type { SharedVolumeCardViewItem, VolumeDiskCardViewItem, VolumeResourceExtraItem } from './types';

function compactExtraItems(items: (VolumeResourceExtraItem | null | undefined | false)[]): VolumeResourceExtraItem[] {
  return items.filter(Boolean) as VolumeResourceExtraItem[];
}

/** 磁盘卡片 extraItems：按字段是否存在自动展示存储类 / 容量 / 回收策略 / 操作系统 */
export function buildDiskVolumeExtraItems(
  item: VolumeDiskCardViewItem,
  t: TFunction,
  options?: { emptyStorageClassFallback?: string },
): VolumeResourceExtraItem[] {
  const storageClassValue = item.storageClassLabel || item.storageClass || options?.emptyStorageClassFallback;
  return compactExtraItems([
    storageClassValue
      ? {
          label: t('common:storage.class'),
          value: storageClassValue,
          frozenWidth: 220,
        }
      : null,
    item.diskSize
      ? {
          label: t('common:capacity'),
          value: `${item.diskSize}Gi`,
          frozenWidth: true,
        }
      : null,
    item.reclaimPolicy
      ? {
          label: t('common:reclaim.policy'),
          value: item.reclaimPolicy,
          frozenWidth: 120,
        }
      : null,
    item.os
      ? {
          label: t('common:operating.system'),
          value: [item.os, item.architecture].filter(Boolean).join(' / '),
          frozenWidth: 240,
        }
      : null,
  ]);
}

/** 共享卷卡片 extraItems */
export function buildSharedVolumeExtraItems(
  item: SharedVolumeCardViewItem,
  t: TFunction,
  options?: { showMountPath?: boolean },
): VolumeResourceExtraItem[] {
  const showMountPath = options?.showMountPath ?? true;
  return compactExtraItems([
    item.storage
      ? {
          label: t('common:capacity'),
          value: item.storage,
          frozenWidth: true,
        }
      : null,
    item.mountPath && showMountPath
      ? {
          label: t('data-center:maas.model.mountPath'),
          value: item.mountPath,
          frozenWidth: 200,
        }
      : null,
  ]);
}
